import { links } from 'common/helpers/links'


const routeParams = {}

const iterate = (links: any, pagePath = '', analyticParams = {}): void => {
  Object.keys(links).forEach((key) => {
    const value = links[key]

    if ('root' in value) {
      const { root, ...rest } = value
      const { path, analytics = {} } = root

      const fullPath = pagePath ? `${pagePath}/${path}` : `/${path}`

      routeParams[fullPath] = { ...analyticParams, ...analytics }

      iterate(rest, fullPath, analytics)
    }
    else {
      const { path, analytics } = value
      const fullPath = pagePath ? `${pagePath}/${path}` : `/${path}`

      routeParams[fullPath] = { ...analyticParams, ...analytics }
    }
  })
}

iterate(links)

if (typeof window !== 'undefined') {
  if (!window.__debug__) {
    window.__debug__ = {}
  }

  window.__debug__.snowplowRouteParams = routeParams
}


export default routeParams
